var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 10.8125C16.1328 10.8125 16.5625 11.2422 16.5625 11.75C16.5625 12.2969 16.1328 12.6875 15.625 12.6875C15.0781 12.6875 14.6875 12.2969 14.6875 11.75C14.6875 11.2422 15.0781 10.8125 15.625 10.8125ZM16.875 7.375C18.5938 7.375 20 8.78125 20 10.5V15.5C20 15.8516 19.6875 16.125 19.375 16.125H16.875V19.875C16.875 20.2266 16.5625 20.5 16.25 20.5H3.75C3.39844 20.5 3.125 20.2266 3.125 19.875V16.125H0.625C0.273438 16.125 0 15.8516 0 15.5V10.5C0 8.78125 1.36719 7.375 3.125 7.375V1.75C3.125 1.08594 3.63281 0.5 4.29688 0.5H12.9688C13.4375 0.5 13.9453 0.734375 14.2969 1.08594L16.2891 3.07812C16.6406 3.42969 16.875 3.9375 16.875 4.40625V7.375ZM5 2.375V7.375H15V4.875H13.125C12.7734 4.875 12.5 4.60156 12.5 4.25V2.375H5ZM15 18.625V16.125H5V18.625H15ZM18.125 14.25V10.5C18.125 9.83594 17.5391 9.25 16.875 9.25H3.125C2.42188 9.25 1.875 9.83594 1.875 10.5V14.25H18.125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint2);
export default __webpack_public_path__ + "static/media/print2.8accd834753c4971209de16b6e2c4e68.svg";
export { ForwardRef as ReactComponent };